import { render } from "./quotenew-cmp.vue?vue&type=template&id=6487df66"
import script from "./quotenew-cmp.vue?vue&type=script&lang=js"
export * from "./quotenew-cmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__